"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var _overlay = _interopRequireDefault(require("@paprika/overlay"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _extractChildren2 = _interopRequireDefault(require("@paprika/helpers/lib/extractChildren"));

var _FocusLock = _interopRequireDefault(require("./components/FocusLock"));

var sc = _interopRequireWildcard(require("./Modal.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var Modal = function Modal(props) {
  var a11yText = props.a11yText,
      isOpen = props.isOpen,
      onClose = props.onClose,
      onAfterClose = props.onAfterClose,
      onAfterOpen = props.onAfterOpen,
      size = props.size,
      zIndex = props.zIndex,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "isOpen", "onClose", "onAfterClose", "onAfterOpen", "size", "zIndex"]);

  var _extractChildren = (0, _extractChildren2["default"])(moreProps.children, ["Modal.FocusLock", "Modal.Overlay", "Modal.Header", "Modal.Content", "Modal.Footer"]),
      focusLockExtracted = _extractChildren["Modal.FocusLock"],
      overlayExtracted = _extractChildren["Modal.Overlay"],
      headerExtracted = _extractChildren["Modal.Header"],
      contentExtracted = _extractChildren["Modal.Content"],
      footerExtracted = _extractChildren["Modal.Footer"],
      children = _extractChildren.children;

  var focusLockProps = focusLockExtracted ? focusLockExtracted.props : {};
  var overlayProps = overlayExtracted ? overlayExtracted.props : {};

  var focusLockOptions = _objectSpread({
    as: sc.FocusLock,
    lockProps: {
      size: size
    }
  }, focusLockProps || {});

  var ariaLabel = a11yText || (headerExtracted ? headerExtracted.props.children : null);
  return /*#__PURE__*/_react["default"].createElement(_overlay["default"], (0, _extends2["default"])({
    "data-pka-anchor": "modal.overlay",
    isOpen: isOpen,
    onClose: onClose,
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    zIndex: zIndex
  }, overlayProps, {
    focusLockOptions: focusLockOptions
  }), function (state) {
    return /*#__PURE__*/_react["default"].createElement(sc.Modal, (0, _extends2["default"])({
      size: size,
      "data-pka-anchor": "modal.wrapper"
    }, moreProps), /*#__PURE__*/_react["default"].createElement(sc.Dialog, {
      state: state,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": ariaLabel,
      "data-pka-anchor": "modal"
    }, headerExtracted && /*#__PURE__*/_react["default"].createElement(sc.Header, (0, _extends2["default"])({}, headerExtracted.props, {
      onClose: onClose
    })), /*#__PURE__*/_react["default"].createElement(sc.ContentWrapper, {
      role: "region",
      tabIndex: "0"
    }, contentExtracted && /*#__PURE__*/_react["default"].createElement(sc.Content, contentExtracted.props), children), footerExtracted && /*#__PURE__*/_react["default"].createElement(sc.Footer, footerExtracted.props)));
  });
};

Modal.types = {
  size: constants.defaultSize
};
var propTypes = {
  /* Description of the Modal dialog for assistive technology */
  a11yText: _propTypes["default"].string,

  /** The content for the Modal. */
  children: _propTypes["default"].node.isRequired,

  /** Control the visibility of the modal */
  isOpen: _propTypes["default"].bool.isRequired,

  /** Callback triggered when the modal needs to be closed */
  onClose: _propTypes["default"].func,

  /** Callback once the modal has been opened event */
  onAfterOpen: _propTypes["default"].func,

  /** Callback once the modal has been closed event */
  onAfterClose: _propTypes["default"].func,

  /* Control the size (max-width) of the modal */
  size: _propTypes["default"].oneOf([Modal.types.size.SMALL, Modal.types.size.MEDIUM, Modal.types.size.LARGE]),

  /** The z-index of the Takeover content */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  a11yText: null,
  onAfterClose: function onAfterClose() {},
  onAfterOpen: function onAfterOpen() {},
  onClose: function onClose() {},
  size: Modal.types.size.MEDIUM,
  zIndex: (0, _helpers.zValue)(6)
};
Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.FocusLock = _FocusLock["default"];
var _default = Modal;
exports["default"] = _default;
//# sourceMappingURL=Modal.js.map